<template>
    <v-row no-gutters class="pl-10 pt-8">
        <v-col cols="8">
            <div>
                <div class="font-weight-medium title">
                    {{ $t("project_app_overview_text") }}
                </div>
                <div
                    class="body-2 wrap pt-2"
                    v-html="$options.filters.nl2br($t('project_app_overview_description'))"
                ></div> <!-- INPUT FROM STATIC TRANSLATION -->
            </div>
        </v-col>
        <v-col cols="4">
            <AppStoreDialogSidebar />
        </v-col>
    </v-row>
</template>

<script>
import AppStoreDialogSidebar from "@/components/AppStore/AppStoreDialogSidebar";

export default {
    name: "ProjectDialogOverviewTab",
    components: {
        AppStoreDialogSidebar
    }
};
</script>
